'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _UtmsToPath;

var _AllowedUtms = require('./AllowedUtms');

var _AllowedUtms2 = _interopRequireDefault(_AllowedUtms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UtmsToPath = (_UtmsToPath = {}, _defineProperty(_UtmsToPath, _AllowedUtms2.default.UTM_SOURCE, 'utm_source'), _defineProperty(_UtmsToPath, _AllowedUtms2.default.UTM_MEDIUM, 'utm_medium'), _UtmsToPath);

exports.default = UtmsToPath;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.15/js/constants/UtmsToPath.js
// module id = 427
// module chunks = 0